import React, { useState } from "react";
import { FaBox, FaExclamationTriangle, FaTimesCircle } from "react-icons/fa";
import tw from "tailwind-styled-components";
import { MdOutlineChevronRight } from "react-icons/md";
import Tooltip from "../../Tooltip";

function SummaryCards({ summaryData, onClick }) {
    const [selectedId, setSelectedId] = useState(null);

    const currentInventoryData = [
        {
            amount: '₹' + summaryData?.currentStockValue || 0,
            subTitle: (summaryData?.totalItems || '0'),
            label: "Stock Value",
            subLabel: `Total Items`,
            color: "text-black",
            icon: <FaBox className="text-black" />,
            filter: 'ALL',
        },
        {
            amount: summaryData?.lowStock || 0,
            label: "Low Stock (<5)",
            color: "text-black",
            icon: <FaExclamationTriangle className="text-black" />,
            filter: 'LS',
        },
        {
            amount: summaryData?.outOfStock || 0,
            label: "Out of Stock",
            color: "text-black",
            icon: <FaTimesCircle className="text-black" />,
            filter: 'OOS',
        },
    ];

    return (
        <Wrapper>
            <ScrollCard>
                {currentInventoryData.map((item) => {
                    const isSelected = selectedId === item.filter;

                    return (
                        <Card
                            key={item.filter}
                            $selected={isSelected}
                            onClick={() => {
                                setSelectedId(isSelected ? null : item.filter);
                                onClick(isSelected ? "ALL" : item.filter);
                            }}
                        >
                            <ValueRow>
                                <Value color={item.color}>{item.amount}</Value>
                                {item.subTitle && (
                                    <Tooltip label={item.subLabel}>
                                        <>
                                            <span className="ml-1 mt-auto mb-1 text-sm text-gray-600">
                                                ({item.subTitle})
                                            </span>
                                            <span className="cursor-help text-xs text-gray-400">
                                                ⓘ
                                            </span>
                                        </>
                                    </Tooltip>
                                )}
                                {/* <IconWrapper>{item.icon}</IconWrapper> */}
                            </ValueRow>
                            <Label>
                                {item.label}
                                <ArrowWrap className="arrow">
                                    <Chevron />
                                </ArrowWrap>
                            </Label>
                        </Card>
                    );
                })}
            </ScrollCard>
        </Wrapper>
    );
}

const Wrapper = tw.div`w-full`;
const ScrollCard = tw.div`w-full overflow-x-auto flex space-x-4 py-1`;
const IconWrapper = tw.div`ml-2`;

const Card = tw.div`
    group min-w-[200px]
    rounded-lg bg-white
    p-4 cursor-pointer
    border border-gray-100
    shadow-sm
    transition-all duration-200
    hover:shadow-md hover:border-gray-200
    ${({ $selected }) =>
        $selected
            ? "border-primary-color shadow-md"
            : ""}
`;

const ValueRow = tw.div`
    flex items-baseline gap-1
`;

const Value = tw.div`
    text-xl font-semibold text-gray-900
    ${({ color }) => color || "text-gray-900"}
`;

const Label = tw.div`
    flex mt-2 text-sm text-gray-500 items-center justify-between
`;

const ArrowWrap = tw.div`
    flex items-center
    text-gray-300
    transition-all duration-200
`;

const Chevron = tw(MdOutlineChevronRight)`
    text-lg
    transform translate-x-0
    opacity-60
    group-hover:opacity-100
    group-hover:text-gray-500
    group-hover:translate-x-1
`;

export default SummaryCards;